// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__1B9Ge","image":"styles_image__3NLK1","words":"styles_words__GrUBC","placeholder":"styles_placeholder__1VRl7"};